"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _excluded = ["className", "loading", "loadingMessage", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(3),
      boxSizing: 'border-box',
      boxShadow: theme.customShadows.small,
      borderRadius: 10,
      backgroundColor: 'white',
      position: 'relative',
      overflow: 'hidden'
    },
    minHeightWithLoading: {
      minHeight: theme.spacing(12)
    },
    minHeightWithLoadingMessage: {
      minHeight: theme.spacing(16)
    }
  };
});
var Card = function Card(_ref) {
  var className = _ref.className,
    loading = _ref.loading,
    loadingMessage = _ref.loadingMessage,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx["default"])(classes.root, loading && (loadingMessage ? classes.minHeightWithLoadingMessage : classes.minHeightWithLoading), className)
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    loading: loading,
    message: loadingMessage,
    variant: "absolute"
  }), children);
};
Card.propTypes = {
  className: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  loadingMessage: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
Card.defaultProps = {
  className: undefined,
  loading: false,
  loadingMessage: undefined
};
var _default = exports["default"] = Card;